module.exports = __webpack_public_path__ + "img/delete_icon.5c6f3f9d.svg";